{
  "phasePanel": {
    "filesColumnFile": "Fichier",
    "filesColumnDescription": "Description",
    "filesColumnStatus": "Statut"
  },
  "tabs": {
    "plan": "Plan",
    "designEffective": "Conception effective",
    "operatingEffective": "Fonctionnement effectif",
    "report": "Rapport",
    "ariaLabel": "Sections de l'audit"
  },
  "phase": {
    "designEffective": {
      "filesTitle": "Documentation de conception",
      "runsTitle": "Analyses de conception effective",
      "runHeading": "Analyse de conception effective {{version}}"
    },
    "operatingEffective": {
      "filesTitle": "Journaux et enregistrements",
      "runsTitle": "Analyses de fonctionnement effectif",
      "runHeading": "Analyse de fonctionnement effectif {{version}}"
    }
  },
  "plan": {
    "title": "Plan d'audit",
    "meta": "v{{version}} · {{count}} éléments",
    "approved": "Approuvé",
    "approve": "Approuver le plan",
    "approving": "Approbation…",
    "approveFailed": "Le plan n’a pas pu être approuvé. Réessayez.",
    "approveWarning": "L'approbation du plan fige la liste des éléments. Vous ne pourrez plus la modifier ensuite.",
    "emptyTitle": "Aucun plan",
    "emptyHint": "Ajoutez un descriptif ou des documents de périmètre ci-dessous, puis générez le plan.",
    "loadFailed": "Impossible de charger le plan. Réessayez.",
    "briefTitle": "Descriptif (facultatif)",
    "scopeTitle": "Documents de périmètre",
    "scopeUpload": "Téléverser des documents de périmètre",
    "scopeUploadFailed": "Échec du téléversement des documents de périmètre. Veuillez réessayer.",
    "scopeDeleteFailed": "Échec de la suppression du document de périmètre. Veuillez réessayer.",
    "readbackFailed": "Le plan n’a pas pu être chargé. Veuillez actualiser pour lire le plan enregistré."
  },
  "files": {
    "phaseRunInProgress": "Les téléversements et les modifications des éléments probants de {{phase}} sont suspendus pendant son analyse.",
    "phaseIngestInProgress": "Les éléments probants de {{phase}} sont en cours d’ingestion. Attendez la fin avant de lancer cette analyse.",
    "serialPipeline": "Les téléversements et le traitement des deux phases attendent la fin du traitement des fichiers en cours.",

    "count_one": "{{count}} fichier",
    "count_other": "{{count}} fichiers",
    "reading_one": "{{count}} en lecture",
    "reading_other": "{{count}} en lecture",
    "lockedByRun": "Vous ne pouvez pas ajouter de fichiers pendant une analyse. Ajoutez-en une fois l'analyse terminée, puis relancez-la.",
    "lockedByChecklist": "Approuvez la liste de contrôle de cet onglet pour ajouter des fichiers."
  },
  "coverage": {
    "title": "Vérification de la couverture",
    "explain": "Bennie compare vos fichiers à la liste de contrôle de cet onglet et vous indique ce qui manque avant de lancer l'analyse.",
    "waiting": "En attente de la fin de la lecture",
    "waitingHint": "Vous ne pouvez pas lancer l'analyse pendant la lecture des fichiers. Elle sera disponible une fois la lecture terminée.",
    "checking": "Vérification de vos fichiers",
    "recheck": "Revérifier",
    "covered": "{{covered}} élément(s) sur {{total}} disposent de preuves",
    "advisory": "Vous pouvez tout de même lancer l'analyse.",
    "unavailable": "Aucune vérification de la couverture n'a été effectuée sur ces fichiers.",
    "loadFailed": "Impossible de charger la vérification de la couverture. Réessayez.",
    "stalled": "La vérification de couverture prend plus de temps que prévu. Vous pouvez tout de même lancer l'analyse, ou revérifier plus tard."
  },
  "run": {
    "start": "Lancer l'analyse",
    "starting": "Démarrage…",
    "inProgressHeading": "Analyse des éléments",
    "itemsAnalysed": "Éléments analysés : {{count}} sur {{total}}",
    "progressUnavailable": "Progression indisponible",
    "startedAt": "Démarrée à {{time}}",
    "stage": "Étape",
    "stageUnknown": "Préparation",
    "stageGenerating": "Lecture de vos fichiers",
    "stageExtracting": "Collecte des constats",
    "stageSequencing": "Classement des constats",
    "stageAggregating": "Regroupement des problèmes",
    "stageChecking": "Vérification de la cohérence",
    "stageDone": "Finalisation",
    "columnVersion": "Version",
    "columnStarted": "Démarrée",
    "columnStatus": "Statut",
    "columnFiles": "Fichiers",
    "columnSummary": "Résumé",
    "open": "Ouvrir",
    "latest": "Dernière",
    "emptyTitle": "Aucune analyse",
    "emptyHint": "Ajoutez vos fichiers, puis lancez l'analyse pour obtenir un verdict sur chaque élément de la liste de contrôle.",
    "loadFailed": "Impossible de charger l'historique des analyses. Réessayez.",
    "failedSummary": "L'analyse n'a pas pu aboutir. Réessayez.",
    "status": {
      "queued": "En file d'attente",
      "running": "En cours",
      "completed": "Terminée",
      "failed": "Échouée"
    },
    "blocked": {
      "ingest_in_progress": "Vos fichiers sont encore en cours de lecture. Lancez l'analyse une fois la lecture terminée.",
      "run_in_progress": "Une analyse est déjà en cours. Attendez sa fin, puis relancez-la.",
      "report_in_progress": "Un rapport est en cours de génération. Attendez sa fin, puis relancez l'analyse.",
      "plan_not_approved": "Approuvez d'abord le plan.",
      "workspace_locked": "Cet audit est verrouillé et ne peut pas être modifié.",
      "evidence_not_ingested": "Certains fichiers téléversés n'ont pas encore été ingérés. Cliquez sur Ingérer les données, puis lancez l'analyse.",
      "evidence_ingest_failed": "Un fichier de cette analyse n'a pas pu être ingéré. Supprimez-le ou téléversez-le à nouveau, cliquez sur Ingérer les données, puis lancez l'analyse.",
      "evidence_deletion_incomplete": "Un fichier de cette analyse n'a pas pu être entièrement supprimé. Essayez de le supprimer à nouveau, puis lancez l'analyse.",
      "generic": "L'analyse n'a pas pu être lancée. Réessayez.",
      "audit_phase_checklist_not_approved": "Approuvez d'abord la liste de contrôle de cet onglet."
    },
    "admissionLoading": "Vérification du démarrage de l’analyse…",
    "admissionFailed": "Impossible de vérifier si l’analyse peut démarrer. Actualisez la page et réessayez."
  },
  "verdict": {
    "Effective": "Effectif",
    "EffectiveWithExceptions": "Avec exceptions",
    "PartiallyEffective": "Partiellement effectif",
    "NotEffective": "Non effectif",
    "NotConcluded": "Sans conclusion",
    "count": "{{count}} {{label}}"
  },
  "runItems": {
    "columnItem": "Élément de la liste",
    "columnVerdict": "Verdict",
    "columnIssues": "Problèmes",
    "analysed": "Analysé, vérifications en attente",
    "failed": "Échec de l’analyse",
    "waiting": "En attente",
    "stateUnavailable": "État de l’élément indisponible",
    "empty": "Aucun élément de la liste de contrôle à afficher.",
    "exportExcel": "Exporter vers Excel",
    "exporting": "Export en cours…",
    "exportFailed": "Échec de l'export Excel",
    "columnExplanation": "Explication",
    "loadFailed": "Impossible de charger la liste de contrôle de cette analyse. Réessayez.",
    "issueLogHeading": "Problèmes issus de cette analyse"
  },
  "item": {
    "close": "Fermer",
    "findingsHeading": "Ce que Bennie a constaté",
    "issuesHeading": "Problèmes liés à cet élément",
    "noBody": "Cet élément n'a aucun résultat enregistré.",
    "loadFailed": "Impossible de charger cet élément. Réessayez.",
    "breadcrumb": "{{phase}} v{{version}} · {{itemId}}",
    "explanationHeading": "Explication",
    "dataGap": "Les éléments probants étaient insuffisants pour conclure sur cet élément.",
    "contextDegraded": "Une partie des documents de référence n'a pas pu être utilisée lors de l'analyse de cet élément ; l'analyse peut donc être incomplète. Relancez la phase pour réessayer.",
    "citedSources": "Sources citées"
  },
  "report": {
    "versionLabel": "Rapport V{{version}}",
    "current": "Actuel",
    "generatedAt": "Généré {{time}}",
    "expand": "Afficher cette version",
    "collapse": "Masquer cette version",
    "generateNew": "Générer une nouvelle version",
    "emptyTitle": "Aucun rapport",
    "emptyHint": "Lancez d'abord les deux analyses. Le rapport sera disponible une fois qu'une analyse de conception effective et une analyse de fonctionnement effectif seront terminées.",
    "loadFailed": "Impossible de charger les versions du rapport. Réessayez.",
    "reingestRequired": "Certains fichiers de cet audit n'ont pas pu être lus ; le rapport ne peut donc pas être reconstruit à partir d'eux. Relancez l'ingestion de données pour cet audit, puis générez à nouveau le rapport.",
    "generateFailed": "Le rapport n'a pas pu être lancé. Réessayez.",
    "emptyHintReady": "Les deux analyses sont terminées. Générez une nouvelle version pour créer le rapport.",
    "statusGenerating": "Génération en cours",
    "statusFailed": "Échec",
    "failed": {
      "report_generation_crashed": "Cette version n'a pas pu être générée. Vos analyses n'ont pas été modifiées. Utilisez « Générer une nouvelle version ».",
      "report_generation_cancelled": "Cette version a été arrêtée avant la fin. Vos analyses n'ont pas été modifiées. Utilisez « Générer une nouvelle version ».",
      "auditing_phase2_entered": "Cette version a été arrêtée avant de pouvoir modifier les résultats d'analyse. Rien n'a été supprimé. Utilisez « Générer une nouvelle version ».",
      "report_version_settle_failed": "Cette version est terminée mais n'a pas pu être enregistrée comme rapport actuel. Vos analyses n'ont pas été modifiées. Utilisez « Générer une nouvelle version ».",
      "report_overarching_failed": "Cette version n’a pas pu produire ses problèmes au niveau du rapport. Vos analyses n’ont pas été modifiées. Utilisez « Générer une nouvelle version ».",
      "report_overarching_not_done": "Cette version s’est terminée sans ses problèmes au niveau du rapport ; elle n’a donc pas été enregistrée comme rapport actuel. Vos analyses n’ont pas été modifiées. Utilisez « Générer une nouvelle version ».",
      "report_cohort_park_unreachable": "Cette version s'est arrêtée avec des sections qui ne pouvaient être ni relancées ni acceptées. Vos analyses n'ont pas été modifiées. Utilisez « Générer une nouvelle version ».",
      "generic": "Cette version n'a pas pu être générée. Vos analyses n'ont pas été modifiées. Utilisez « Générer une nouvelle version ».",
      "halted": "Cette version s'est arrêtée car la génération est en pause en raison d'un problème en amont. Vos analyses n'ont pas été modifiées. Utilisez « {{clearHalt}} » pour reprendre, puis générez une nouvelle version."
    },
    "blocked": {
      "plan_not_stable": "Approuvez d'abord le plan.",
      "ingest_in_progress": "Vos fichiers sont encore en cours de lecture. Générez le rapport une fois la lecture terminée.",
      "run_in_progress": "Une analyse est en cours. Générez le rapport une fois qu'elle est terminée.",
      "report_in_progress": "Une version du rapport est déjà en cours de génération. Attendez qu'elle se termine.",
      "report_version_in_progress": "Une version du rapport est déjà en cours de génération. Attendez qu'elle se termine.",
      "report_runs_incomplete": "Le rapport nécessite une analyse de conception effective terminée et une analyse de fonctionnement effectif terminée. Lancez celle qui manque, puis générez le rapport.",
      "report_generation_unfinished": "La dernière version du rapport ne s'est pas terminée. Ouvrez-la ci-dessous et utilisez Commentaire ou Réessayer depuis le début sur chaque section inachevée, puis générez une nouvelle version une fois toutes les sections terminées.",
      "generation_in_progress": "Une version du rapport est en cours de génération. Attendez qu'elle se termine, puis générez à nouveau."
    },
    "preflightTitle": "Générer une nouvelle version",
    "preflightIntro": "La nouvelle version est construite à partir de ces listes de contrôle approuvées et de ces analyses terminées.",
    "preflightChecklist": "Liste de contrôle v{{version}} · {{count}} éléments",
    "preflightNoChecklist": "Aucune liste de contrôle approuvée",
    "preflightRun": "Analyse v{{version}} · {{status}}",
    "preflightNoRun": "Aucune analyse terminée",
    "preflightCancel": "Annuler",
    "preflightFailed": "Impossible de charger ce que la nouvelle version utilisera. Réessayez.",
    "exportExcel": "Exporter vers Excel",
    "exporting": "Export en cours…",
    "exportFailed": "Échec de l'export Excel",
    "preflightLoading": "Vérification de la disponibilité du rapport…",
    "sectionsBeingWritten": "Les sections sont en cours de rédaction.",
    "references": {
      "count_one": "{{count}} document",
      "count_other": "{{count}} documents",
      "location": "Emplacement",
      "content": "Contenu"
    },
    "issues": {
      "title": "Journal des problèmes",
      "count_one": "{{count}} problème",
      "count_other": "{{count}} problèmes",
      "finding": "Constat"
    }
  },
  "chat": {
    "open": "Demander à Bennie",
    "collapse": "Réduire",
    "title": "Demander à Bennie",
    "ariaExpand": "Ouvrir la conversation",
    "ariaCollapse": "Fermer la conversation",
    "answeringFor": "Réponses pour {{tab}}"
  },
  "checklist": {
    "titleDe": "Liste de contrôle de conception",
    "titleOe": "Liste de contrôle de fonctionnement",
    "meta": "v{{version}} · {{count}} éléments",
    "approved": "Approuvée",
    "approve": "Approuver la liste",
    "approving": "Approbation…",
    "approveWarning": "Approuver la liste de contrôle fige ses éléments. Vous ne pourrez plus les modifier ensuite.",
    "loadFailed": "Impossible de charger la liste de contrôle. Réessayez.",
    "loading": "Chargement de la liste de contrôle…",
    "lockedByPlan": "Approuvez le plan pour créer la liste de contrôle de conception.",
    "lockedByDe": "Approuvez la liste de contrôle de conception pour créer la liste de contrôle de fonctionnement.",
    "generate": "Générer la liste",
    "generating": "Génération…",
    "generatingHint": "Cela peut prendre quelques minutes.",
    "emptyHintDe": "Bennie établit la liste de contrôle de conception à partir de votre plan approuvé.",
    "emptyHintOe": "Bennie établit la liste de contrôle de fonctionnement à partir de votre liste de conception approuvée.",
    "edit": "Modifier",
    "remove": "Supprimer",
    "add": "+ Ajouter un élément",
    "save": "Enregistrer",
    "saving": "Enregistrement…",
    "cancel": "Annuler",
    "required": "Obligatoire",
    "fieldTitle": "Élément",
    "fieldDescription": "Ce qu'il faut vérifier",
    "fieldMethod": "Comment",
    "fieldMethodOptional": "Comment le vérifier (facultatif)",
    "fieldRefs": "Éléments de conception testés",
    "testsDesignItems": "Teste : {{items}}",
    "actionFailed": "Cette modification n'a pas pu être enregistrée. Réessayez.",
    "generationStalled": "La liste de contrôle prend plus de temps que prévu. Rechargez la page pour vérifier, ou générez-la de nouveau.",
    "retry": "Réessayer",
    "generationIncomplete": "La liste de contrôle n'a pas été générée. Réessayez."
  },
  "failure": {
    "timedOut": "Cela prend plus de temps que prévu. Réessayez.",
    "network": "Impossible de joindre Bennie. Vérifiez votre connexion et réessayez.",
    "unexpectedResponse": "Bennie a renvoyé une réponse inattendue. Réessayez."
  },
  "scrollLines": {
    "goTo": "Aller à la section {{index}} sur {{count}}"
  }
}
